// extracted by mini-css-extract-plugin
module.exports = {"container":"Milestone_container__Ysf0W","body":"Milestone_body__2CGj7","menu":"Milestone_menu__3iidd","message":"Milestone_message__QfHLB","date":"Milestone_date__9B3Gz"};